import { IconProps } from "../../utils/global-types/global-types";

const SendIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_5212_83586)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12.446 5.554 7.166 9.22 1.643 7.38a.94.94 0 0 1 .009-1.788l14.12-4.547a.941.941 0 0 1 1.183 1.184l-4.547 14.12a.94.94 0 0 1-1.787.008l-1.85-5.55z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_5212_83586">
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SendIcon;
